import { render, staticRenderFns } from "./contact_form.vue?vue&type=template&id=1a2680ec&scoped=true&"
import script from "./contact_form.vue?vue&type=script&lang=js&"
export * from "./contact_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2680ec",
  null
  
)

export default component.exports